module.exports = __webpack_public_path__ + "9779d9a1/img/ion_calendar-number.3ac5bd07.svg";